module.exports = __webpack_public_path__ + "img/chinesecompany27.0cbd3307.png";